import { BreadcrumbsSchema } from '~shared/constants/breadcrumbs-schema.constants';
import { Category } from '~app/modules/generic/models';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { environment } from '~env/environment';

export namespace BreadcrumbsSchemaGeneratorUtil {
  export function generateSchema(breadcrumbs: Category[]) {
    return {
      '@context': BreadcrumbsSchema.context,
      '@type': BreadcrumbsSchema.type,
      'itemListElement': generate(breadcrumbs)
    };
  }
}

function generate(breadcrumbs: Category[]) {
  return breadcrumbs.reduce((acc: Category[], category: Category, position: number) => {
    return [
      ...acc,
      {
        '@type': BreadcrumbsSchema.itemType,
        position: position + 1,
        name: category.name,
        item: `${environment.appBaseUrl()}/${APP_CATEGORY_ROUTE}/${category.slug}`
      }];
  }, []);
}
